// extracted by mini-css-extract-plugin
export default {"wrapper":"ImageEditorTrigger_wrapper__qDa8G","disabled":"ImageEditorTrigger_disabled__Vev2m"};